import { createBrowserHistory } from 'history'; //https://github.com/ReactTraining/history/blob/master/docs/GettingStarted.md

// Calendrier
import clndr from 'clndr';



$(document).ready(function(){

  ////////////////////////////////////////////////////
  //
  //  GESTION CALENDRIER ET DOCUMENTS
  //
  ////////////////////////////////////////////////////

  let history = createBrowserHistory();
  let location = history.location;


  //Écouter les changements d'url et lancer la recherche
  let unlisten = history.listen(({ location, action }) => {

    if ( history.location.pathname.includes("calendrier") )  recherche_calendrier(history.location.search);
    else recherche(history.location.search);
  });

  function updateURL(url,key,val){
    var reExp = new RegExp("[\?|\&]"+key + "=[0-9a-zA-Z\_\+\-\|\.\,\;]*");
    if(reExp.test(url)) {
        // update
        var reExp = new RegExp("[\?&]" + key + "=([^&#]*)");
        var delimiter = reExp.exec(url)[0].charAt(0);
        url = url.replace(reExp, delimiter + key + "=" + val);
    } else {
        // add
        var newParam = key + "=" + val;
        if(url.indexOf('?')<0){
          //console.log('ajoute'+url.indexOf('?'))
          url += '?';
        }
        if(url.indexOf('#') > -1){
            var urlparts = url.split('#');
            url = urlparts[0] +  "&" + newParam +  (urlparts[1] ?  "#" +urlparts[1] : '');
        } else {
            url += "&" + newParam;
        }
    }
    return url;

  }

  //////////////////////////
  //
  //  RECHERCHE CALENDRIER
  //
  //////////////////////////


  // Initialisation du calendrier et chargement prochaine dates
  if ($('#calendrier').length)  {

    moment.locale('fr');

    var theCalendarInstance =  $('#calendrier').clndr({
      moment: moment,
      startWithMonth: moment(),
      daysOfTheWeek: [ 'L', 'M', 'M', 'J', 'V', 'S','D'],
      weekOffset: 0,
      adjacentDaysChangeMonth: true,
      events: Myevents,
      clickEvents: {
        click: function(target) {
          chargeDates(target.events);
        },
        onMonthChange: function(month) {
          //console.log('you just went to ' + month.format('MMMM, YYYY'));
        }
      },
    });

    recherche_calendrier(history.location.search);
    menu_themes_calendrier();


  }

  $('.main-container ').on('change','select#choix-theme', function() {

    var url = updateURL( window.location.search,'d', '' );
    url = updateURL(url,'t', this.value );
    history.push(url);

  });


  function chargeDates(events) {
    if (events.length >0) {
      var dates =[];
      for (var d in events) {
          dates.push(events[d].id);
      }
      var url = updateURL(window.location.search,'t', 0 );
      url = updateURL(url,'d', dates.join(',') );
      history.push(url);
      // Reset selecteur de thèmes
      menu_themes_calendrier();
    }
  }

  function menu_themes_calendrier() {
    $('#choix-theme').html('');
    var url = new URL(window.location);
    var t = url.searchParams.get("t");


    $.ajax({
      type: "POST",
      dataType: "json",
      url: ajax_url,
      data: { param:'?t='+t,action:'menu_themes_calendrier'},
      success: function(response, statut){

         $('#choix-theme').html(response);
      },
      error : function(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(jqXHR.responseText);
          console.log(jqXHR.responseText + " :: " + textStatus + " :: " + errorThrown);
      }
    });
  }


  function recherche_calendrier(params) {

    $('#resultat').html('');
    $('#zone-titre').html('');
    $('#nbr').html('');
    $('#loader').show();

    $('html,body').scrollTop(0);

    $.ajax({
      type: "POST",
      dataType: "json",
      url: ajax_url,
      data: { param:params,action:'recherche_calendrier'},
      success: function(response, statut){

         $('#resultat').html(response.contenu);
         //$('#nbr').html(response.nbr);
         $('#zone-titre').html(response.titre);
         $('#loader').hide();

      },
      error : function(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(jqXHR.responseText);
          console.log(jqXHR.responseText + " :: " + textStatus + " :: " + errorThrown);
      }
  });

  }




  //////////////////////////
  //
  //  RECHERCHE DOCUMENTS
  //
  //////////////////////////

  // Si on est sur la page de recherche
  if ($('.form-recherche-documents').length) {
    recherche(history.location.search);
    updateTitre( loadTerm );
  }



  // Reset recherche
  document.getElementById("search-field").addEventListener("search", function(event) {
    $("#resultat").empty();
    recherche(history.location.search);
  });


  // Choix catégorie
  $(" a.adherents-menu-categories-item").on("click", function(event) {
    event.preventDefault();

    $("a.adherents-menu-categories-item").removeClass('actif');
    $("a.adherents-menu-sous-categories-item").removeClass('actif');
    $(this).addClass('actif');
    $('.search-field').val('');

    // Tester si il existe une sous catégorie : dans ce cas pas de recherche, on affiche juste les sous catégories
    let sousCat =  $(this).next('ul');

    if (sousCat.length>0) {

          // Vider la page et afficher les sous menus dans la page
          $('#resultat').html('');
          $('#pour').html('');
          $('#nbr').html('');
          $('#pagination').html('');

          $('#resultat').html(sousCat.clone());

    }
    else { // Pas de sous catégories, on affiche tout

       // Changer l'url et le titre de la page
      var url = updateURL(location.search,'term', $(this).data('term') );
      history.push(url);
      recherche(history.location.search)
      updateTitre($(this).data('term'));
    }

  })
  // Choix sous catégorie
  $(" a.adherents-menu-sous-categories-item").on("click", function(event) {
    event.preventDefault();
    $("a.adherents-menu-sous-categories-item").removeClass('actif');
    $(this).addClass('actif');
    $('.search-field').val('');

    // Changer l'url et le titre de la page
     var url = updateURL(location.search,'term',$(this).data('term') );
     history.push(url);
     recherche(history.location.search);
     updateTitre($(this).data('term'));
  })


  // Pagination
  $(".main-content-recherche").on("click", '.pagination-adherents a', function(event) {
    event.preventDefault();
    // Changer l'url
     var url = updateURL(location.search,'p',$(this).data('page') );
     if ( $(this).data('term') !== 'undefined' ) url = updateURL(url,'term',$(this).data('term') );
     history.push(url);
     recherche(history.location.search)
  })


  function updateTitre(term) {
    let titre = $( 'a[data-term=' + term + ']').html();
    if (titre.length > 0) $('h2.categorie-active').html(titre);
    else $('h2.categorie-active').html('Tous les documents');
  }


  // Recherche mot clé
  $('.search-submit').on('click', function( event ){
      event.preventDefault();
      let s = $('.search-field').val();
      if (history.location.search.length > 0) recherche(history.location.search+'&s='+s);
      else recherche('?s='+s);
  })
  // Recherche : getsion touceh entrée
  $('form.form-recherche-documents').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      $( ".search-submit" ).trigger( "click" );
      return false;
    }
  });




  function recherche (params) {
    $('#resultat').html('');
    $('#loader').show();
    $('#pour').html('');
    $('#nbr').html('');
    $('#pagination').html('');
    $('html,body').scrollTop(0);

    if ( $('.search-field').val().length>0 ) {
      $('#pour').html('Pour votre recherche "'+$('.search-field').val()+'"');
    }

      $.ajax({
          type: "POST",
          dataType: "json",
          url: ajax_url,
          data: { param:params,action:'recherche_adherents'},
          success: function(response, statut){

             $('#loader').hide();
             $('#resultat').html(response.contenu);
             $('#pagination').html(response.pagination);
             $('#nbr').html(response.nbr);

          },
          error : function(jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
              console.log(jqXHR.responseText);
              console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
          }
      });
  }


});
